import api from './api';

export const generateTxnSignature = ({ nameFunction, params }) =>
  api.post(`/trading/signature`, { nameFunction, params });

export const getChestMintSignature = ({ userChestTokenIds }) =>
  api.post(`/trading/chest-mint-signatures`, { userChestTokenIds });

export const getGoldPurchaseSignature = ({ amount, paymentToken }) =>
  api.get(`/trading/gold-purchase-signatures`, { params: { amount, paymentToken } });

export const validateGoldPurchaseTransaction = ({ transactionHash }) =>
  api.post('/trading/gold-purchase-transactions', { transactionHash });

export const getPackPurchaseSignature = ({ packId, paymentToken }) =>
  api.get(`/trading/pack-purchase-signatures`, { params: { packId, paymentToken } });

export const validatePackPurchaseTransaction = ({ transactionHash, packId }) =>
  api.post('/trading/pack-purchase-transactions', { transactionHash, packId });

export const getDivingTicketPurchaseSignature = ({ mode, paymentToken }) =>
  api.get(`/trading/diving-ticket-purchase-signatures`, { params: { mode, paymentToken } });

export const validateDivingTicketPurchaseTransaction = ({ transactionHash, mode }) =>
  api.post(`/trading/diving-ticket-purchase-transactions`, { transactionHash, mode });

export const validateDailyCheckinTransaction = ({ transactionHash }) =>
  api.post('/user-quests/trigger-online-check-in', { transactionHash });

export const validatePurchaseTournamentTicketTransaction = ({ transactionHash }) =>
  api.post('/trading/purchase-tournament-ticket', { transactionHash });

export const validateOpenChestTransaction = ({ transactionHash }) =>
  api.post('/trading/open-nft-chest', { transactionHash });

export const validateOpenLuckyChestTransaction = ({ transactionHash }) =>
  api.post('/trading/open-lucky-chest', { transactionHash });

export const validateWithdrawChestTransaction = ({ transactionHash }) =>
  api.post('/trading/withdraw-nft-chest', { transactionHash });

export const validateDepositRodTransaction = ({ transactionHash }) =>
  api.post('/trading/deposit-nft-rod', { transactionHash });

export const validateWithdrawRodTransaction = ({ transactionHash }) =>
  api.post('/trading/withdraw-nft-rod', { transactionHash });

export const validateRepairRodTransaction = ({ transactionHash, tokenId }) =>
  api.post('/trading/repair-nft-rod', { transactionHash, tokenId });

export const validateMintFishTransaction = ({ transactionHash }) =>
  api.post(`/trading/mint-nft-fish`, { transactionHash });

export const validateDepositFishTransaction = ({ transactionHash }) =>
  api.post(`/trading/deposit-nft-fish`, { transactionHash });

export const validateWithdrawFishTransaction = ({ transactionHash }) =>
  api.post(`/trading/withdraw-nft-fish`, { transactionHash });

export const validateCollectFishTransaction = ({ fish, transactionHash }) =>
  api.post('/trading/add-collection-nft-fish-minted', { fish, transactionHash });

export const tokenSpinSignature = () => api.get(`/trading/token-wheel-spin-signatures`, {});

export const validateTokenWheelTransaction = ({ wheelType, transactionHash }) =>
  api.post('/user-quests/daily-quest/wheel/spin', { wheelType, transactionHash });
